import React, { useState, useEffect } from 'react';

const DarkContactsCardTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,businessHoursTabData }) => {
    const [showHours, setShowHours] = useState(false);
            
    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/business-hours/temp-css/BusinessHoursWidget.css`;
        if (widgetId) {
            link.setAttribute("business-hours-data-dynamic-css", "business-hours");
        } else {
            link.setAttribute("data-dynamic-css", "business-hours");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="business-hours"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    const {
        is_website_frontend,
        is_sunday_on,
        sunday_start_time,
        sunday_end_time,
        is_monday_on,
        monday_start_time,
        monday_end_time,
        is_tuesday_on,
        tuesday_start_time,
        tuesday_end_time,
        is_wednesday_on,
        wednesday_start_time,
        wednesday_end_time,
        is_thursday_on,
        thursday_start_time,
        thursday_end_time,
        is_friday_on,
        friday_start_time,
        friday_end_time,
        is_saturday_on,
        saturday_start_time,
        saturday_end_time,
        business_name,
        about_company,
        phone_number,
        email,
        website,
        address,
        is_show_labels_on,
        is_show_icons_on,
        background_color,
        text_color,
        icons_color,
        open_status_color,
        closed_status_color,
        closed_soon_status_color,
        text_size,
        position_alignment,
        layout_custom_width,
    } = businessHoursTabData || {};

    const days = [
        { name: "Sunday", isOpen: Number(is_sunday_on), start: sunday_start_time, end: sunday_end_time },
        { name: "Monday", isOpen: Number(is_monday_on), start: monday_start_time, end: monday_end_time },
        { name: "Tuesday", isOpen: Number(is_tuesday_on), start: tuesday_start_time, end: tuesday_end_time },
        { name: "Wednesday", isOpen: Number(is_wednesday_on), start: wednesday_start_time, end: wednesday_end_time },
        { name: "Thursday", isOpen: Number(is_thursday_on), start: thursday_start_time, end: thursday_end_time },
        { name: "Friday", isOpen: Number(is_friday_on), start: friday_start_time, end: friday_end_time },
        { name: "Saturday", isOpen: Number(is_saturday_on), start: saturday_start_time, end: saturday_end_time },
    ];

    const parse12HourTime = (timeStr) => {
        const date = new Date();
        const [time, modifier] = timeStr.split(" ");
        let [hours, minutes] = time.split(":").map(Number);

        if (modifier === "PM" && hours < 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;

        date.setHours(hours, minutes, 0, 0);
        return date;
    };

    const currentDay = new Date().getDay();
    const now = new Date();
    const today = days[currentDay];

    let businessStatus = "closed";
    let h4Content = "";

    if (today.isOpen && today.start && today.end) {
        const startTime = parse12HourTime(today.start);
        const endTime = parse12HourTime(today.end);

        if (now < startTime) {
            businessStatus = "closed";
            h4Content = `Opens today at ${today.start}`;
        } else if (now >= endTime) {
            businessStatus = "closed";
            // Find next open day
            let nextOpen = null;
            for (let i = 1; i <= 7; i++) {
                const nextIndex = (currentDay + i) % 7;
                if (days[nextIndex].isOpen) {
                    nextOpen = days[nextIndex];
                    break;
                }
            }
            h4Content = nextOpen ? `Opens ${nextOpen.name} at ${nextOpen.start}` : "Closed";
        } else {
            const minutesLeft = Math.floor((endTime - now) / 60000);
            if (minutesLeft <= 60) {
                businessStatus = "closingSoon";
                h4Content = `Closing soon in ${minutesLeft} min${minutesLeft > 1 ? "s" : ""}`;
            } else {
                businessStatus = "open";
                h4Content = `Open until ${today.end}`;
            }
        }
    } else {
        // Today is closed, find next open day
        let nextOpen = null;
        for (let i = 1; i <= 7; i++) {
            const nextIndex = (currentDay + i) % 7;
            if (days[nextIndex].isOpen) {
                nextOpen = days[nextIndex];
                break;
            }
        }
        h4Content = nextOpen ? `Opens ${nextOpen.name} at ${nextOpen.start}` : "Closed";
    }

    const statusColors = {
        open: open_status_color,
        closingSoon: closed_soon_status_color,
        closed: closed_status_color,
    };

    const statusColor = statusColors[businessStatus];

    return (
        <>
            <div className={`business_main upgadeify business-hours-dark-contacts-card-temp ${is_website_frontend}`}>
            <div className='' style={{ backgroundColor: background_color, borderRadius: "12px", padding: "30px 30px", width: layout_custom_width}}>
                    <div className='full_businesshours_box'>
                        <div className='small'>
                          <img src={`${process.env.PUBLIC_URL}/business-hours/templates/dark-contacts-card-img.png`} alt='business logo' style={{ width: "100%", height: "320px", marginBottom: "15px", objectFit:"cover",borderRadius: "12px 12px 0 0" }} />
                        </div>
                        <h4 className='title_business' style={{ color: text_color, textAlign: position_alignment }}>{business_name}</h4>
                        <h3 className='abount_company' style={{ color: text_color, textAlign: position_alignment }}>{about_company}</h3>
                     
                        <div className='full_businesshours_btns'>
                            {/* Book Appointment Button */}
                            <button
                                className='business_btn'
                                style={{
                                    background: "linear-gradient(131deg, #FE8100 -4.12%, #F5FF00 100%)",
                                    color: "#000",
                                    fontSize: "15px",
                                    fontWeight: "600",
                                    display: "flex",
                                }}
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                >
                                    <path
                                        d="M3 10H21M7 3V5M17 3V5M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                                        stroke="#000"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Book Appointment
                            </button>

                            <a href={`tel:${phone_number}`}>
                                <button
                                    className='business_btn'
                                    style={{
                                        background: "linear-gradient(131deg, #FE8100 -4.12%, #F5FF00 100%)",
                                        color: "#000",
                                        fontSize: "15px",
                                        fontWeight: "600",
                                        display: "flex",
                                    }}
                                >
                                <svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" style={{ fill: "#000", width: "24px", height: "24px", marginRight: "4px" }}>
                                            <path
                                                fillRule="evenodd"
                                                d="M6.264 1.9H4.007a2.104 2.104 0 0 0-2.098 2.295 15.486 15.486 0 0 0 2.41 6.799 15.286 15.286 0 0 0 4.706 4.696 15.538 15.538 0 0 0 6.766 2.4 2.104 2.104 0 0 0 2.309-2.104V13.73a2.102 2.102 0 0 0-1.814-2.122 9.113 9.113 0 0 1-1.994-.495l-.166-.054a2.11 2.11 0 0 0-2.056.528l-.63.628-.268-.17a11.455 11.455 0 0 1-3.238-3.231l-.171-.267.627-.624a2.11 2.11 0 0 0 .53-2.07l-.053-.155a9.046 9.046 0 0 1-.494-1.982A2.11 2.11 0 0 0 6.263 1.9ZM4.008 3.1H6.27a.91.91 0 0 1 .914.779c.1.762.289 1.516.56 2.24a.904.904 0 0 1-.204.957l-.955.953a.6.6 0 0 0-.098.722 12.655 12.655 0 0 0 4.75 4.741.6.6 0 0 0 .72-.097l.959-.956a.91.91 0 0 1 .956-.202c.728.271 1.483.46 2.252.56a.905.905 0 0 1 .776.918v2.273a.905.905 0 0 1-.99.908c-2.218-.24-4.357-1-6.237-2.217a14.099 14.099 0 0 1-4.345-4.334 14.283 14.283 0 0 1-2.225-6.268.91.91 0 0 1 .905-.978Z"
                                            />
                                            </svg>
                                    Call Now
                                </button>
                            </a>

                            {/* WhatsApp Button */}
                            <a href="https://api.whatsapp.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }} >
                                <button
                                    className='business_btn'
                                    style={{
                                        background: "#0d883b",
                                        color: "#fff",
                                        fontSize: "15px",
                                        fontWeight: "400"
                                    }}
                                >
                                    <svg
                                        width="20px"
                                        height="20px"
                                        viewBox="0 0 20 20"
                                        fill="#fff"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ marginRight: "5px" }}
                                    >
                                        <path d="M10 0C4.48 0 0 4.477 0 10c0 1.77.463 3.434 1.27 4.893L0 20l5.19-1.26A9.98 9.98 0 0010 20c5.523 0 10-4.477 10-10S15.523 0 10 0zm5.066 14.316c-.217.61-1.27 1.188-1.77 1.254-.477.062-1.084.088-1.746-.113-.402-.123-.917-.299-1.583-.626-2.79-1.305-4.6-4.525-4.74-4.733-.14-.206-1.132-1.507-1.132-2.88 0-1.372.717-2.048.972-2.331.256-.281.556-.352.743-.352.186 0 .372.003.534.01.173.006.4-.064.627.478.24.565.818 1.956.89 2.096.074.14.123.306.025.491-.098.186-.147.3-.294.464-.147.162-.31.361-.444.485-.147.137-.3.286-.129.56.17.272.757 1.246 1.623 2.017 1.118.992 2.062 1.302 2.334 1.447.272.145.429.123.587-.074.16-.198.673-.78.854-1.048.18-.27.37-.222.624-.133.256.09 1.62.764 1.894.902.274.137.457.204.523.317.065.113.065.65-.152 1.26z" />
                                    </svg>
                                    Chat on WhatsApp
                                </button>
                            </a>

                             {/* Get Directions Button */}
                             <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
                                target="_blank"
                                rel="noopener noreferrer">
                                    <button
                                    className='business_btn'
                                    style={{
                                        background: "#fff",
                                        color: "#000",
                                        fontSize: "15px",
                                        fontWeight: "400"
                                    }}
                                >
                                    <svg
                                        fill="#000"
                                        width="20px"
                                        height="20px"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ marginRight: "5px" }}
                                    >
                                        <path d="M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z" />
                                    </svg>
                                    Get Directions
                                </button>
                            </a>
                        </div>

                        <div className='full_business_contact'>
                                <div className='full_business_contact_detail'>
                                    {phone_number && (
                                        <span className='fullbusiness_action' style={{ color: text_color, fontSize: text_size, textAlign: position_alignment }}>
                                            {Number(is_show_icons_on) === 1 && (
                                                <svg xmlns="http://www.w3.org/2000/svg" width={text_size} height={text_size} viewBox="0 0 24 24" fill={icons_color} style={{ marginRight: "5px", verticalAlign: "middle" }}>
                                                <path fillRule="evenodd" d="M6.264 1.9H4.007a2.104 2.104 0 0 0-2.098 2.295 15.486 15.486 0 0 0 2.41 6.799 15.286 15.286 0 0 0 4.706 4.696 15.538 15.538 0 0 0 6.766 2.4 2.104 2.104 0 0 0 2.309-2.104V13.73a2.102 2.102 0 0 0-1.814-2.122 9.113 9.113 0 0 1-1.994-.495l-.166-.054a2.11 2.11 0 0 0-2.056.528l-.63.628-.268-.17a11.455 11.455 0 0 1-3.238-3.231l-.171-.267.627-.624a2.11 2.11 0 0 0 .53-2.07l-.053-.155a9.046 9.046 0 0 1-.494-1.982A2.11 2.11 0 0 0 6.263 1.9ZM4.008 3.1H6.27a.91.91 0 0 1 .914.779c.1.762.289 1.516.56 2.24a.904.904 0 0 1-.204.957l-.955.953a.6.6 0 0 0-.098.722 12.655 12.655 0 0 0 4.75 4.741.6.6 0 0 0 .72-.097l.959-.956a.91.91 0 0 1 .956-.202c.728.271 1.483.46 2.252.56a.905.905 0 0 1 .776.918v2.273a.905.905 0 0 1-.99.908c-2.218-.24-4.357-1-6.237-2.217a14.099 14.099 0 0 1-4.345-4.334 14.283 14.283 0 0 1-2.225-6.268.91.91 0 0 1 .905-.978Z" />
                                                </svg>
                                            )}
                                            {Number(is_show_labels_on) === 1 && (
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Phone:
                                                </label>
                                            )}
                                            <a
                                            href={`tel:${phone_number}`}
                                            style={{
                                                color: text_color,
                                                fontSize: text_size,
                                                textAlign: position_alignment,
                                                textDecoration: 'none',
                                                verticalAlign: "middle"
                                            }}
                                            >
                                            {phone_number}
                                            </a>
                                        </span>
                                    )}

                                    {/* Address */}
                                    {address && (
                                    <span className='fullbusiness_action' style={{ color: text_color, fontSize: text_size, textAlign: position_alignment }}>
                                        {Number(is_show_icons_on) === 1 && (
                                            <svg xmlns="http://www.w3.org/2000/svg"  width={text_size} height={text_size} viewBox="0 0 24 24" fill={icons_color} style={{ marginRight: "5px", verticalAlign: "middle" }}>
                                            <path fillRule="evenodd" d="M10.002 1.067a7.418 7.418 0 0 1 7.418 7.418c0 2.505-1.348 4.976-3.574 7.325a23.43 23.43 0 0 1-2.405 2.2l-.212.166-.398.303-.34.246-.157.108a.6.6 0 0 1-.665 0l-.156-.108-.341-.246-.398-.303-.212-.166a23.43 23.43 0 0 1-2.405-2.2c-2.226-2.35-3.574-4.82-3.574-7.325a7.418 7.418 0 0 1 7.419-7.418Zm0 1.2a6.218 6.218 0 0 0-6.219 6.218c0 2.134 1.21 4.352 3.245 6.5a22.243 22.243 0 0 0 2.282 2.086l.392.305.299.222.3-.222.392-.305c.778-.62 1.557-1.32 2.282-2.086 2.035-2.148 3.245-4.366 3.245-6.5a6.218 6.218 0 0 0-6.218-6.218Zm0 3.345a2.873 2.873 0 1 1 0 5.746 2.873 2.873 0 0 1 0-5.746Zm0 1.2a1.673 1.673 0 1 0 0 3.346 1.673 1.673 0 0 0 0-3.346Z" />
                                            </svg>
                                        )}
                                        {Number(is_show_labels_on) === 1 && (
                                            <label style={{ fontWeight: 'bold' }}> Address: </label>
                                        )}
                                        <a
                                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: text_color, fontSize: text_size, textDecoration: 'none', verticalAlign: "middle" }}
                                        >
                                        {address}
                                        </a>
                                    </span>
                                    )}

                                    {/* Email */}
                                    {email && (
                                    <span className='fullbusiness_action' style={{ color: text_color, fontSize: text_size, textAlign: position_alignment }}>
                                        {Number(is_show_icons_on) === 1 && (
                                            <svg xmlns="http://www.w3.org/2000/svg" width={text_size} height={text_size} viewBox="0 0 24 24" fill={icons_color} style={{ marginRight: "5px", verticalAlign: "middle" }}>
                                            <path fillRule="evenodd" d="m3.179 4.909 7.321 5.188 7.321-5.188a1.023 1.023 0 0 0-.978-.753H4.157c-.463 0-.858.32-.978.753Zm14.68 1.385-7.032 4.982a.565.565 0 0 1-.654 0L3.142 6.294v8.523c0 .563.458 1.027 1.015 1.027h12.686c.557 0 1.015-.464 1.015-1.027V6.293ZM2 5.184C2 3.98 2.97 3 4.157 3h12.686C18.031 3 19 3.981 19 5.183v9.633C19 16.02 18.03 17 16.843 17H4.157C2.969 17 2 16.019 2 14.816V5.184Z" clipRule="evenodd" />
                                            </svg>
                                        )}
                                        {Number(is_show_labels_on) === 1 && (
                                            <label style={{ fontWeight: 'bold' }}> Email: </label>
                                        )}
                                        <a
                                        href={`mailto:${email}`}
                                        style={{ color: text_color, fontSize: text_size, textDecoration: 'none', verticalAlign: "middle" }}
                                        >
                                        {email}
                                        </a>
                                    </span>
                                    )}

                                    {/* Website */}
                                    {website && (
                                    <span className='fullbusiness_action' style={{ color: text_color, fontSize: text_size, textAlign: position_alignment }}>
                                        {Number(is_show_icons_on) === 1 && (
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={text_size} height={text_size} fill={icons_color} style={{ marginRight: "5px", verticalAlign: "middle" }}>
                                            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 
                                            10-4.486 10-10S17.514 2 12 2zm6.93 
                                            6h-2.021a13.01 13.01 0 0 0-1.317-3.472A8.038 
                                            8.038 0 0 1 18.93 8zM12 4c.783 1.014 
                                            1.473 2.354 1.89 4H10.11C10.527 
                                            6.354 11.217 5.014 12 4zM8.408 
                                            4.528A13.01 13.01 0 0 0 7.09 
                                            8H5.07a8.038 8.038 0 0 1 
                                            3.338-3.472zM4 12c0-.683.087-1.345.242-1.974h3.025A15.66 
                                            15.66 0 0 0 7 12c0 .667.09 1.321.267 
                                            1.974H4.242A7.951 7.951 0 0 1 4 
                                            12zm1.07 4h2.021a13.01 13.01 0 0 0 
                                            1.317 3.472A8.038 8.038 0 0 1 5.07 16zM12 
                                            20c-.783-1.014-1.473-2.354-1.89-4h3.78c-.417 
                                            1.646-1.107 2.986-1.89 4zm3.592-0.528A13.01 
                                            13.01 0 0 0 16.91 16h2.021a8.038 8.038 
                                            0 0 1-3.338 3.472zM16.733 14.026A15.66 
                                            15.66 0 0 0 17 12c0-.667-.09-1.321-.267-1.974h3.025c.155.63.242 
                                            1.291.242 1.974s-.087 1.345-.242 1.974h-3.025zM14.776 
                                            14.026H9.224A13.204 13.204 0 0 1 9 
                                            12c0-.706.075-1.391.224-2.026h5.552c.149.635.224 
                                            1.32.224 2.026s-.075 1.391-.224 2.026z"/>
                                            </svg>
                                        )}
                                        {Number(is_show_labels_on) === 1 && (
                                            <label style={{ fontWeight: 'bold' }}> Website: </label>
                                        )}
                                        <a
                                        href={website.startsWith('http') ? website : `https://${website}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: text_color, fontSize: text_size, textDecoration: 'none', verticalAlign: "middle" }}
                                        >
                                        {website}
                                        </a>
                                    </span>
                                    )}

                                    <span className='fullbusiness_action open_status_business' style={{ color: statusColor, fontSize: text_size, textAlign: position_alignment }} onClick={() => setShowHours(!showHours)}>
                                        {Number(is_show_icons_on) === 1 && (
                                            <svg width={text_size} height={text_size} viewBox="0 0 24 24" fill="none" stroke={icons_color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="10" />
                                            <polyline points="12 6 12 12 16 14" />
                                        </svg>
                                    )}
                                    {Number(is_show_labels_on) === 1 && (
                                        <label style={{ fontWeight: 'bold' }}>
                                            Hours:
                                        </label>
                                    )}
                                    &nbsp;{h4Content}</span>
                                </div>

                                {/* Business Hours Table */}
                                {showHours && (
                                <div className='table_dropbox' style={{ backgroundColor: "rgb(17, 17, 17)",}}>
                                    <table>
                                        {days.map((day, index) => {
                                            const isToday = index === currentDay;
                                            const isClosedBySetting = !day.isOpen;
                                            const isBold = isToday ? "bold" : "normal";
                                            const dayLabel = isToday ? "Today" : day.name;
                                            const timeText = isClosedBySetting ? "Closed" : `${day.start} - ${day.end}`;
                    
                                            let rowColor = text_color;
                    
                                            if (isClosedBySetting) {
                                                rowColor = closed_status_color;
                                            } else if (isToday) {
                                                const startTime = parse12HourTime(day.start);
                                                const endTime = parse12HourTime(day.end);
                                                const isOpenNow = now >= startTime && now < endTime;
                                                if (!isOpenNow) {
                                                    rowColor = closed_status_color;
                                                }
                                            }
                    
                                            return (
                                                <tr key={index}>
                                                    <td style={{ color: rowColor, fontSize: text_size, fontWeight: isBold, textAlign: position_alignment }}>
                                                        {dayLabel}
                                                    </td>
                                                    <td style={{ color: rowColor, fontSize: text_size, fontWeight: isBold, textAlign: position_alignment }}>
                                                        {timeText}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DarkContactsCardTemplateWidget;
